import { render, staticRenderFns } from "./DoneEmpty.vue?vue&type=template&id=1b88aca8&scoped=true&"
import script from "./DoneEmpty.vue?vue&type=script&lang=js&"
export * from "./DoneEmpty.vue?vue&type=script&lang=js&"
import style0 from "./DoneEmpty.vue?vue&type=style&index=0&id=1b88aca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88aca8",
  null
  
)

export default component.exports